module.exports = __webpack_public_path__ + "img/icon-room-lounge.befd9c31.svg";